var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 40,
    viewBox: "0 0 46 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4748 0.136536H37.0375C36.6003 0.136536 36.1932 0.370547 35.9746 0.755532L29.5969 11.9352C29.2802 12.4863 28.4887 12.4863 28.1721 11.9352L21.7944 0.763081C21.5757 0.378095 21.1686 0.144084 20.7314 0.144084H7.26734C6.8301 0.144084 6.42301 0.378095 6.20439 0.763081L0.165919 11.3389C-0.301478 12.1617 0.286538 13.1808 1.22887 13.1808H12.7706C13.449 13.1808 13.9994 13.7318 13.9994 14.4112V14.6528C13.9994 14.9094 13.9315 15.1585 13.8034 15.385L6.90549 27.4781C6.68687 27.8555 6.68687 28.3235 6.90549 28.7009L12.9364 39.2616C13.4114 40.0844 14.5949 40.0844 15.0699 39.2616L28.1796 16.2908C28.4962 15.7398 29.2878 15.7398 29.6044 16.2908L35.9821 27.4705C36.2007 27.8555 36.6078 28.0895 37.0451 28.0895H37.4823C37.9196 28.0895 38.3266 27.8555 38.5453 27.4705L45.1718 15.8606C45.4733 15.3321 45.6316 14.7282 45.6316 14.1168C45.6316 13.5053 45.4733 12.909 45.1718 12.373L38.5377 0.763081C38.3191 0.378095 37.912 0.144084 37.4748 0.144084V0.136536Z",
    fill: "#F713AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4748 0.136536H37.0375C36.6003 0.136536 36.1932 0.370547 35.9746 0.755532L29.5969 11.9352C29.2802 12.4863 28.4887 12.4863 28.1721 11.9352L21.7944 0.763081C21.5757 0.378095 21.1686 0.144084 20.7314 0.144084H7.26734C6.8301 0.144084 6.42301 0.378095 6.20439 0.763081L0.165919 11.3389C-0.301478 12.1617 0.286538 13.1808 1.22887 13.1808H12.7706C13.449 13.1808 13.9994 13.7318 13.9994 14.4112V14.6528C13.9994 14.9094 13.9315 15.1585 13.8034 15.385L6.90549 27.4781C6.68687 27.8555 6.68687 28.3235 6.90549 28.7009L12.9364 39.2616C13.4114 40.0844 14.5949 40.0844 15.0699 39.2616L28.1796 16.2908C28.4962 15.7398 29.2878 15.7398 29.6044 16.2908L35.9821 27.4705C36.2007 27.8555 36.6078 28.0895 37.0451 28.0895H37.4823C37.9196 28.0895 38.3266 27.8555 38.5453 27.4705L45.1718 15.8606C45.4733 15.3321 45.6316 14.7282 45.6316 14.1168C45.6316 13.5053 45.4733 12.909 45.1718 12.373L38.5377 0.763081C38.3191 0.378095 37.912 0.144084 37.4748 0.144084V0.136536Z",
    fill: "url(#paint0_linear_1_645)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_645",
    x1: 0.0020752,
    y1: 0.136536,
    x2: 34.2243,
    y2: 44.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8000FF",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8000FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnly);
export default __webpack_public_path__ + "static/media/logo-only.5df122949031ab8e6777ed2129bf54e8.svg";
export { ForwardRef as ReactComponent };